<template>
  <div class="title">修改密码</div>
  <a-form :model="formData" :rules="rules" class="form" ref="formRef">
    <!-- <a-form-item name="oldPassword" class="form-item">
      <template v-slot:label>
        <div class="label">旧密码</div>
      </template>
      <div class="content">
        <a-input-number
          v-model:value="formData.oldPassword"
          style="width: 100%"
          placeholder="请输入旧密码"
          type="password"
        />
      </div>
    </a-form-item> -->

    <a-form-item name="newPassword" class="form-item">
      <template v-slot:label>
        <div class="label">新密码</div>
      </template>
      <div class="content">
        <a-input
          v-model:value="formData.newPassword"
          style="width: 100%"
          placeholder="请输入新密码"
          type="password"
        />
      </div>
    </a-form-item>
  </a-form>

  <div class="footer">
    <div class="cancel" @click="cancelChangePawword">取消</div>
    <div class="queck" @click="reAddLease">确定</div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref } from "vue";
import { Toast } from "@/utils/index";
// import { updateAfterSalePassword } from "@/request/view/afterSale";
import { saveOrUpdateUser } from "@/request/view/repair";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default defineComponent({
  setup() {
    const router = useRouter();
    const store = useStore();
    const formRef = ref();
    const formData = reactive({
      oldPassword: "",
      newPassword: "",
    });

    const cancelChangePawword = () => {
      formData.oldPassword = "";
      formData.newPassword = "";
      router.back();
    };

    const rules = {
      newPassword: [
        {
          required: true,
          message: "请输入新密码",
        },
      ],
      // oldPassword: [
      //   {
      //     required: true,
      //     message: "请输入旧密码",
      //   },
      // ],
    };

    const reAddLease = () => {
      formRef.value.validateFields().then(() => {
        saveOrUpdateUser({
          id: store.state.user.user.id,
          password: formData.newPassword,
        })
          .then((res) => {
            if (res.code === 200) {
              cancelChangePawword();
              Toast("success", res.message, 3);
            } else {
              Toast("waring", res.message, 3);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    };

    return {
      rules,
      formRef,
      formData,
      reAddLease,
      cancelChangePawword,
    };
  },
});
</script>

<style lang="less" scoped>
@import url("../mobile/components/less/form.less");
.footer {
  margin-top: 2rem;
}
.form {
  padding-top: 1rem;
  background: #fff;
}
</style>